import { Box, Stack } from "@mui/material";
import { getIn, useFormikContext } from "formik";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import { AddSolutionFormValues } from "../../../add/form/types";
import { EditSolutionFormValues } from "../../../edit/form/types";
import NumberField from "./NumberField";

const scoreFields = [
  {
    id: "solution-carbon-score",
    label: "Carbon",
    path: "pillars.carbon.scores.total",
  },
  {
    id: "solution-biodiversity-score",
    label: "Biodiversity",
    path: "pillars.biodiversity.scores.total",
  },
  {
    id: "solution-people-score",
    label: "People",
    path: "pillars.people.scores.total",
  },
] as const;

function ScoresContainer({ open }: { open: boolean }) {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  return (
    <Box data-testid="writeable-scores-container">
      <SectionCollapsible open={open} label="Scores">
        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          {scoreFields.map(({ id, label, path }) => {
            const error = getIn(context.errors, path) as string | undefined;
            const touched = getIn(context.touched, path) as boolean | undefined;
            const value = getIn(context.values, path) as number | undefined;

            return (
              <NumberField
                key={path}
                id={id}
                label={label}
                min={0}
                max={10}
                step={0.1}
                smallStep={0.1}
                snapOnStep
                value={value ?? null}
                onValueChange={(nextValue) =>
                  context.setFieldValue(path, nextValue ?? undefined)
                }
                size="small"
                onValueCommitted={() => context.setFieldTouched(path, true)}
                error={Boolean(touched && error)}
                helperText={error}
              />
            );
          })}
        </Stack>
      </SectionCollapsible>
    </Box>
  );
}

export default ScoresContainer;
